import { Entreprise } from '../../intervenant/models/entreprise.model';
import { Utilisateur } from '../../intervenant/models/utilisateur.model';
import { Operateur } from '../../intervenant/models/operateur.model';
import { Produit } from '../../habilitation/models/produit.model';
import { DateConverter } from 'src/app/core/services/mapper/converters';

export class SuiviParcellairesViticoles {
    static jsonMap = {
        idDeclaration: { key: 'idDeclaration', optional: true },
        idEntreprise: { key: 'idEntreprise', optional: true },
        idUniteCulturale: { key: 'idUniteCulturale', optional: true },
        dateDerniereMaj: { key: 'dateDerniereMaj', converter: new DateConverter(), optional: true },
        dateDerniereValidation: { key: 'dateDerniereValidation', converter: new DateConverter(), optional: true },
        idAuteurDerniereValidation: { key: 'idAuteurDerniereValidation', optional: true },
        surfacePlantee: { key: 'surfacePlantee', optional: true },
        surfaceEngagee: { key: 'surfaceEngagee', optional: true },
        variete: { key: 'variete', optional: true, default: '' },
        annee: { key: 'annee', optional: true, default: '' },
        anneePlantation: { key: 'anneePlantation', optional: true, default: '' },
        tracabilite: { key: 'tracabilite', optional: true, default: '' },
        referenceCadastrale: { key: 'referenceCadastrale', optional: true, default: '' },
        commune: { key: 'commune', optional: true, default: '' },
        libelleProduit: { key: 'libelleProduit', optional: true, default: '' }
    };

    idDeclaration: number = undefined;
    idEntreprise: number;
    entreprise: Entreprise;
    idUniteCulturale: number;
    dateDerniereMaj: moment.Moment;
    dateDerniereValidation: moment.Moment;
    idAuteurDerniereValidation: number;
    auteurModification: Utilisateur;
    surfacePlantee: number;
    surfaceEngagee: number;
    variete: string;
    annee: string;
    anneePlantation: string;
    tracabilite: string;
    referenceCadastrale: string;
    commune: string;
    libelleProduit: string;
    operateur: Operateur = new Operateur();
    produit: Produit = new Produit();
}
